import PropTypes from 'prop-types';
import ErpCustomerPropType from '../../../../models/CompanyPropType';
import Button from '../../../Button/Button';
import styles from './styles.module.scss';

const ErpCustomerDelete = ({ erpCustomer, onCancel, handleDelete }) => {
  return (
    <div className={styles.column}>
      Möchten Sie den Kunden
      {' "'}
      {erpCustomer.friendlyName}
      {'" '}
      wirklich löschen? Es werden auch alle Nutzer dieses Kunden gelöscht.
      <div className={styles.buttonRow}>
        <Button className={styles.modalButtonSecondary} type="button" onClick={onCancel}>
          Abbrechen
        </Button>
        <Button className={styles.modalButton} type="button" onClick={handleDelete}>
          Löschen
        </Button>
      </div>
    </div>
  );
};

ErpCustomerDelete.propTypes = {
  erpCustomer: ErpCustomerPropType.isRequired,
  onCancel: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
};

export default ErpCustomerDelete;
